// ContactMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const ContactMetaData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ContactPage",
        "@id": "https://www.meatbuddy.in/contact/#webpage",
        "url": "https://www.meatbuddy.in/contact",
        "name": "Contact Meat Buddy - Fresh Meat Delivery in Bengaluru",
        "description": "Contact us for premium meat delivery in Bengaluru. Reach out for orders, support, or queries about our fresh meat products.",
        "isPartOf": { "@id": "https://www.meatbuddy.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://www.meatbuddy.in",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "https://www.meatbuddy.in/contact",
                "name": "Contact Us"
              }
            }
          ]
        }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.meatbuddy.in/#localbusiness",
        "name": "Vistara Farms Private Limited",
        "alternateName": "Meat Buddy",
        "description": "Premium quality fresh meat delivery service in Bengaluru. FSSAI certified with doorstep delivery.",
        "url": "https://www.meatbuddy.in",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.meatbuddy.in/images/logo.png"
        },
        "image": {
          "@type": "ImageObject",
          "url": "https://www.meatbuddy.in/images/store-front.jpg"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "No.158, Padma Upadhyay Layout, Nagadevanahali",
          "addressLocality": "Bengaluru",
          "addressRegion": "Karnataka",
          "postalCode": "560056",
          "addressCountry": "IN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "12.9716",
          "longitude": "77.5946"
        },
        "telephone": "+91-6364740404",
        "email": "support@meatbuddy.in",
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        },
        "areaServed": {
          "@type": "City",
          "name": "Bengaluru",
          "containsPlace": [
            {
              "@type": "Place",
              "name": "Banashankari 3rd stage",
              "postalCode": "560085"
            },
            {
              "@type": "Place",
              "name": "Nagarbhavi",
              "postalCode": "560072"
            },
            {
              "@type": "Place",
              "name": "Kengeri",
              "postalCode": "560060"
            }
          ]
        }
      },
      {
        "@type": "Organization",
        "@id": "https://www.meatbuddy.in/#organization",
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+91-6364740404",
            "contactType": "customer service",
            "email": "support@meatbuddy.in",
            "areaServed": "Bengaluru",
            "availableLanguage": ["English", "Kannada", "Hindi"],
            "hoursAvailable": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "09:00",
              "closes": "18:00"
            }
          },
          {
            "@type": "ContactPoint",
            "telephone": "+91-6364740404",
            "contactType": "sales",
            "areaServed": "Bengaluru",
            "availableLanguage": ["English", "Kannada", "Hindi"]
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.meatbuddy.in/contact/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are your customer service hours?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our customer service team is available from 9 AM to 6 PM, all days of the week."
            }
          },
          {
            "@type": "Question",
            "name": "How can I track my order?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can track your order by contacting our customer service team with your order ID."
            }
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <title>Contact Us - Meat Buddy | Premium Meat Delivery in Bengaluru</title>
      <meta name="title" content="Contact Meat Buddy - Fresh Meat Delivery Service in Bengaluru" />
      <meta name="description" content="Contact Meat Buddy for premium fresh meat delivery in Bengaluru. Customer support available daily 9 AM to 6 PM. FSSAI certified meat shop with doorstep delivery of fresh chicken, mutton, and customized cuts." />
      <meta name="keywords" content="contact meat buddy, meat delivery contact bangalore, meat shop contact, fresh meat delivery contact, meat buddy customer service, meat delivery support bangalore" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.meatbuddy.in/contact" />
      <meta property="og:title" content="Contact Meat Buddy - Fresh Meat Delivery Service" />
      <meta property="og:description" content="Get in touch with Meat Buddy for premium meat delivery in Bengaluru. Customer support available daily. Order fresh, quality meat today!" />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Contact Meat Buddy - Fresh Meat Delivery" />
      <meta name="twitter:description" content="Contact us for premium meat delivery in Bengaluru. Customer support available daily for all your meat delivery needs." />
      
      <link rel="canonical" href="https://www.meatbuddy.in/contact" />
      
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};